import Vue from "vue";
import vuex from "vuex";
import pathify from "./pathify";
import { make } from "vuex-pathify";
import createPersistedState from "vuex-persistedstate";

Vue.use(vuex);
const state = {
  lang: null,
  user: null,
  token: null,
  loading: null,
  gradingConfig: [],
  provinces: [],
  districts: [],
  ethnics: [],
  studentRoles: [],
  batches: [],
  selected_school_id: null, // for superadmin only
};
const mutations = make.mutations(state);
const store = new vuex.Store({
  state,
  mutations,
  plugins: [
    pathify.plugin,
    createPersistedState({
      key: "nappa_student",
      storage: window.localStorage,
    }),
  ],
});

global.store = store;
export default store;
